import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const isCurrentlyActiveDutyMilitary: AnswerPathTreeNode = {
  path: 'isCurrentlyActiveDutyMilitary',
  nodeId: NodeIds.insuredIsCurrentlyActiveDutyMilitary,
};
